<template>
  <ul class="tasks list-unstyled ml-2">
    <task
      v-for="(task, i) in taskData"
      :key="task.id"
      v-model="taskData[i]"
      :variant="variant"
      :editable="editable && !readonly"
      @toggled="updatePercentComplete()"
      :readonly="readonly"
    ></task>
  </ul>
</template>

<style lang="scss" scoped>
.tasks {
  padding-left: 2px;
  .task {
    .task-name {
      display: block;
      margin-bottom: 0.20rem;
      line-height: 1.25rem;
    }
  }
}
</style>

<script>
import Task from '@/components/Task'
import filter from 'lodash/filter'

export default {
  components: {
    Task
  },
  props: {
    list: {
      type: Object,
      required: false,
      default () {
        return {
          id: null,
          percent_complete: 0,
          tasks: []
        }
      }
    },
    tasks: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    variant: {
      type: String,
      default: 'default',
    },
    editable: {
      type: [Boolean],
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      taskData: []
    }
  },
  watch: {
    'list.tasks' () {
      this.taskData = this.list.tasks
    },
    'tasks' () {
      this.taskData = this.tasks
    }
  },
  mounted () {
    if (this.list.tasks.length) {
      this.taskData = this.list.tasks
    } else {
      this.taskData = this.tasks
    }
  },
  methods: {
    updatePercentComplete () {
      if (!this.taskData.length) {
        this.list.percent_complete = 0
      } else {
        this.list.percent_complete = Math.round(100 * filter(this.taskData, (task) => task.done).length / this.taskData.length)
      }
      this.$emit('updated')
    }
  }
}
</script>
